export enum AlertRuleGroupName {
  BATTERY = 'Battery',
  CURRENT = 'Current',
  DEVICE = 'Device',
  DEW_POINT = 'DewPoint',
  HUMIDITY = 'Humidity',
  PRESSURE = 'Pressure',
  SIGNAL = 'Signal',
  TEMPERATURE = 'Temperature',
  VOLTAGE = 'Voltage',
  CONDENSATION_RISK = 'CondensationRisk',
  DEVICE_OFFLINE = 'DeviceOffline',
  EXHAUST_AIR_TOO_COLD = 'ExhaustAirTooCold',
  EXHAUST_AIR_TOO_HOT = 'ExhaustAirTooHot',
  HEATING_WHILE_VALVE_CLOSED = 'HeatingWhileValveClosed',
  LOW_BATTERY = 'LowBattery',
  NO_HEATING = 'NoHeating',
  TARGET_TEMPERATURE_NOT_REACHED = 'TargetTemperatureNotReached',
  TEMPERATURE_RAPID_CHANGE = 'TemperatureRapidChange',
  WEAK_SIGNAL = 'WeakSignal'
}
